import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/permission'

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './common/all.css';
// import locale from 'element-ui/lib/locale/lang/zh-CN';

import echarts from "echarts"
import axios from 'axios';
import countTo from 'vue-count-to'
import BaiduMap from '@/components/vue-baidu-map/components'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '8HqFySu9TNbYj1v8yr0CgOF69UmzXnxp'
})

Vue.use(countTo)
// Vue.use(ElementUI, { locale });
// Vue.prototype.$AMapUI = AMapUI
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$axios = axios;


//zhengshi
Vue.prototype.$visualizationUrl = "http://homeapi.ltylao.com:9988/";
Vue.prototype.$imgUrl = "http://homeimg.ltylao.com/";
Vue.prototype.$websocketUrl= "ws://deviceapi.ltylao.com:50001/websocket/";
Vue.prototype.$shopUrl = "http://shopapi.ltylao.com:9987/";
Vue.prototype.$institutionUrl = "http://insapi.ltylao.com:9985/";
Vue.prototype.$deviceUrl = "http://47.96.251.59:50001/";
Vue.prototype.$communityUrl = "http://comapi.ltylao.com:50002";

Vue.prototype.$signKey = "ED139FA9132F1E60967C8579D1F7B958";

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
